import loadable from '@loadable/component';

export const AdminPanel = loadable(() => import('../AdminPanel'));
